// src/theme.js
import { createTheme } from '@mui/material/styles';
import { red } from '@mui/material/colors';
// Los mismos pesos que components/Layout.js (27-10-2026: sin Google Fonts).
import '@fontsource/montserrat/400.css';
import '@fontsource/montserrat/500.css';
import '@fontsource/montserrat/600.css';
import '@fontsource/montserrat/700.css';
import '@fontsource/montserrat/800.css';
import '@fontsource/montserrat/900.css';
 
const theme = createTheme({
  palette: {
    primary: {
      main: '#163244',
    },
    secondary: {
      main: '#E7A432',
    },
    error: {
      main: red.A400,
    },
  },
  typography: {
    fontFamily: 'Montserrat, sans-serif',
    button: {
      fontFamily: 'Montserrat, sans-serif',
      fontWeight: 400,
      textTransform: 'none',
    },
  },
  components: {
    MuiSelect: {
      styleOverrides: {
        root: {
          width: '100%',
          minWidth: '0 !important',
          boxSizing: 'border-box',
        },
        select: {
          width: '100%',
          minWidth: '0 !important',
        },
      },
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          width: '100%',
          minWidth: '0 !important',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: 'Montserrat, sans-serif',
          fontWeight: 400,
          textTransform: 'none',
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontFamily: 'Montserrat, sans-serif',
          fontWeight: 400,
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          fontFamily: 'Montserrat, sans-serif',
          fontWeight: 400,
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontFamily: 'Montserrat, sans-serif',
          fontWeight: 400,
        },
      },
    },
  },
});
 
export default theme;